import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import styles from './list.styl'

export default class List extends Component {
  static propTypes = {
    large: PropTypes.bool,
    custom: PropTypes.bool,
    loading: PropTypes.bool,
    children: PropTypes.any,
    data: PropTypes.array,
    onSelect: PropTypes.func,
    loaderItemsCount: PropTypes.number
  }
  static defaultProps = {
    large: false,
    custom: false,
    loaderItemsCount: 8
  }

  handleSelect = value => {
    if (this.props.onSelect) {
      this.props.onSelect(value)
    }
  }

  render() {
    const {
      data,
      large,
      loading,
      loaderItemsCount,
      custom,
      children
    } = this.props
    const loader = []

    for (let i = 0; i < loaderItemsCount; i++) {
      loader.push(<div key={i}><div className={styles.content} /></div>)
    }

    return (
      <div>
        <ul className={`${styles.list} ${large && styles.large} `}>
          {!custom &&
            data &&
            data.map((item, index) => (
              <li
                key={index}
                className={`${styles.item} ${item.icon && styles.withIcon} ${large && styles.large} ${item.action && styles.action} `}
                onClick={() => this.handleSelect(item.action)}
              >
                {item.icon &&
                  <span className={`ico ico--${item.icon} ${styles.icon}`} />}
                {item.intlKey
                  ? <FormattedMessage
                      id={item.intlKey}
                      defaultMessage={item.label}
                    />
                  : item.label}
                {item.value !== undefined &&
                  <span className={styles.value}>{item.value}</span>}
              </li>
            ))}
          {custom && children}
        </ul>
        {loading &&
          <div style={{ overflow: 'hidden' }}>
            <div className={styles.loader}>{loader}</div>
          </div>}
      </div>
    )
  }
}
